<div [class.loading]="loading">
    <table *ngIf="!loading">
        <thead>
            <th align="left" class="medium-filter-column">
                <a (click)="sortByColumn('varianceTypeColumn')">{{reportFilters.varianceType}}</a>  
            </th>
            <th align="left" class="small-filter-column" *ngFor='let viewDate of varianceData.xAxis'>            
                <a (click)="sortByColumn(viewDate)">{{viewDate}}</a>
            </th>
        </thead>
        <tr *ngFor='let dataSet of sortableGridData' >
            <td>{{dataSet.varianceTypeColumn}}</td>            
            <td  [ngClass]="{'positive': item >= 0 , 'negative': item < 0}" 
                *ngFor='let item of dataSet.data'>{{item === null ? '-' : item}}
            </td>
        </tr>
    </table>
 </div>
